import React, { useState, useEffect } from "react";

function LoadingAnimation({ isVisible = false }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (!isVisible) {
      setProgress(0);
      return;
    }

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          return 100;
        }
        return prev + Math.random() * 30;
      });
    }, 500);

    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-90 flex items-center justify-center z-50 overflow-hidden">
      {/* Main Container */}
      <div className="flex flex-col items-center justify-center gap-8">
        {/* Text */}
        <div className="text-center">
          <h2 className="text-4xl sm:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-red-400 to-pink-400 italic mb-2">
            LOVE LOADING...
          </h2>
        </div>

        {/* Progress Bar Container */}
        <div className="w-80 sm:w-96">
          {/* Animated progress bar */}
          <div className="relative h-3 bg-gray-700 rounded-full overflow-hidden mb-8">
            <div
              className="h-full bg-gradient-to-r from-pink-500 via-red-500 to-pink-500 rounded-full transition-all duration-300 ease-out shadow-lg"
              style={{
                width: `${Math.min(progress, 100)}%`,
              }}
            ></div>
            {/* Glow effect */}
            <div
              className="absolute inset-0 bg-gradient-to-r from-pink-500 via-red-500 to-pink-500 rounded-full blur-sm opacity-60"
              style={{
                width: `${Math.min(progress, 100)}%`,
              }}
            ></div>
          </div>

          {/* Heart Icons Below Progress Bar */}
          <div className="flex justify-between items-center px-2">
            {/* Heart 1 */}
            <div className="flex justify-center">
              <span
                className="text-3xl animate-bounce"
                style={{ animationDelay: "0s" }}
              >
                ❤️
              </span>
            </div>

            {/* Heart 2 */}
            <div className="flex justify-center">
              <span
                className="text-3xl animate-bounce"
                style={{ animationDelay: "0.2s" }}
              >
                🤍
              </span>
            </div>

            {/* Heart 3 */}
            <div className="flex justify-center">
              <span
                className="text-3xl animate-bounce"
                style={{ animationDelay: "0.4s" }}
              >
                ❤️
              </span>
            </div>

            {/* Heart 4 */}
            <div className="flex justify-center">
              <span
                className="text-3xl animate-bounce"
                style={{ animationDelay: "0.6s" }}
              >
                💖
              </span>
            </div>
          </div>
        </div>

        {/* Optional: Loading percentage text */}
        <p className="text-white text-lg font-semibold mt-4">
          {Math.round(Math.min(progress, 100))}%
        </p>
      </div>

      {/* Floating particles effect */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); opacity: 0.5; }
          50% { transform: translateY(-20px); opacity: 0.8; }
        }
        .floating {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}

export default LoadingAnimation;
